// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// amevi.bogota@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyBGwTGKnPUy6MXdHVP0EUhVmj1moAYbIVM",
    authDomain: "amevi-ecommerce.firebaseapp.com",
    projectId: "amevi-ecommerce",
    storageBucket: "amevi-ecommerce.firebasestorage.app",
    messagingSenderId: "1073487627684",
    appId: "1:1073487627684:web:988586231b19ed316bad31",
    measurementId: "G-3YR7XRHPTS"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)